module.exports = __webpack_public_path__ + "static/testi-1-3-fbf798bca28aa5caa11f77cdb334ba7d.jpg";